import { useState } from 'react'

import { Box, Button, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

export interface SidepanelDataPairProps {
  title: string
  desc: string
  desc2?: string | null
  info?: string
  copyValue?: string
  hideCopyButton?: boolean
  editValue?: string
  onEdit?: (value: string) => void
  hideEditButton?: boolean
}

export function SidepanelDataPair({
  title,
  desc,
  copyValue,
  desc2,
  info,
  hideCopyButton,
  editValue,
  onEdit,
  hideEditButton,
}: SidepanelDataPairProps) {
  const [copy, setCopy] = useState<string>('')

  useEffect(() => {
    if (copy) {
      navigator.clipboard.writeText(copy)
      const timeout = setTimeout(() => {
        setCopy('')
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [copy])

  const [open, toggle] = useToggle(false)

  const handleEdit = () => {
    if (onEdit && editValue) {
      onEdit(editValue)
    }
  }

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Box flexDirection="column" gap="s4">
        <Box flexDirection="row" gap="s4">
          <Text.Normal color="grey1000" weight="semibold">
            {title}
          </Text.Normal>
          {info && (
            <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={info}>
              <Icon.Medium icon={'info-circle-line'} color="grey800" />
            </Tooltip.Alt>
          )}
        </Box>
        <Box flexDirection="row" alignItems="center" gap="s8" justifyContent="spaceBetween">
          <Text.Normal color="grey1000">{desc}</Text.Normal>
        </Box>
        {desc2 && <Text.Normal color="grey1000">{desc2}</Text.Normal>}
      </Box>
      <Box flexDirection="row" gap="s8">
        {!hideEditButton && onEdit && (
          <Button type="secondary" onClick={handleEdit} iconName="pencil" />
        )}
        {!hideCopyButton && (
          <Tooltip.Alt
            open={!!copy}
            attachment="bottom center"
            label={i18n.t('banking.accounts.side_panel.copied')}
            size="small"
            textSize="100"
          >
            <Button
              type={copy ? 'positive' : 'secondary'}
              onClick={copy ? () => null : () => setCopy(copyValue ?? desc)}
              iconName={copy ? 'check' : 'layers-front'}
            />
          </Tooltip.Alt>
        )}
      </Box>
    </Box>
  )
}
